import { render, staticRenderFns } from "./NavigationInset.vue?vue&type=template&id=1793b51e"
import script from "./NavigationInset.vue?vue&type=script&lang=js"
export * from "./NavigationInset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports